import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./CookieConsent.module.css";

const GA_ID = "G-8WFC0RR00R";

const enableAnalytics = () => {
  // Φόρτωση του Google Analytics script μόνο μετά από αποδοχή
  if (window.gtag) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
};

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setShowBanner(true);
    } else if (consent === "true") {
      enableAnalytics(); // Ενεργοποιεί GA αν έχει ήδη δώσει άδεια
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "true");
    enableAnalytics();
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookie-consent", "false");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className={styles.banner} role="dialog" aria-label="Cookie consent">
      <p>
        This website uses analytics cookies to improve experience and track usage.{" "}
        <Link to="/privacy">Learn more</Link>
      </p>
      <div className={styles.buttons}>
        <button onClick={declineCookies} className={styles.secondary}>
          Decline
        </button>
        <button onClick={acceptCookies}>Accept</button>
      </div>
    </div>
  );
};

export default CookieConsent;
